module.exports = __webpack_public_path__ + "static/media/logo-designernews.948250b1.svg";